import React from 'react';
import PCProductForm from './PCProductMISCForm'
import { Paper, withStyles } from "@material-ui/core";
import { hasPermission, parseURL } from '../../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "../store/pcProductActions";
import { getProductType } from "../../../sc-admin/SystemCertificate/utils";

const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        marginTop: '-43px',
        [theme.breakpoints.down('md')]: {
            marginTop: '-21px',
            width: '100%'
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: '-21px',
            width: '100%'
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },

    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const PCProductEditMisc = props => {
    const { product, loading, editable, refresh, classes, activeCustomer, translations, permissions } = props;
    let searchParams = parseURL(window.location.search);

    const handleSubmit = async data => {
        data['ActiveCustomerID'] = activeCustomer;
        data['updateMISCOnly'] = true;
        data['ProductID'] = searchParams.productID;
        await props.onEditPCProduct({ ...data });
    }

    const getSecurazeVersion = (processingSession) => {
        if (processingSession?.ClientType) {
            return `${getProductType(processingSession?.ClientType ?? "", translations)}: ${processingSession?.ClientVersion ?? ""}`;
        }
        return processingSession?.ClientVersion ?? "";
    }

    let initialValues = {
        RAM: product && product.PCProduct && product.PCProduct.RAM ? product.PCProduct.RAM : '',
        Version: product && product.PCProduct && product.PCProduct.Version ? product.PCProduct.Version : '',
        Webcam: product && product.PCProduct && product.PCProduct.Webcam ? product.PCProduct.Webcam : '',
        WebcamVendor: product && product.PCProduct && product.PCProduct.WebcamVendor ? product.PCProduct.WebcamVendor : '',
        Bluetooth: product && product.PCProduct && product.PCProduct.Bluetooth ? product.PCProduct.Bluetooth : '',
        BluetoothVendor: product && product.PCProduct && product.PCProduct.BluetoothVendor ? product.PCProduct.BluetoothVendor : '',
        Resolution: product && product.PCProduct && product.PCProduct.Resolution ? product.PCProduct.Resolution : '',
        ScreenSize: product && product.PCProduct && product.PCProduct.ScreenSize ? product.PCProduct.ScreenSize : '',
        OperatingSystem: product && product.PCProduct && product.PCProduct.OperatingSystem ? product.PCProduct.OperatingSystem : '',
        OemProductKey: product && product.OemProductKey ? product.OemProductKey : '',
        NetworkStandard: product && product.PCProduct && product.PCProduct.NetworkStandard ? product.PCProduct.NetworkStandard : '',
        UUID: product && product.PCProduct && product.PCProduct.UUID ? product.PCProduct.UUID : '',
        SecurazeVersion: getSecurazeVersion(product?.ProcessingSessions?.[0]),
        HardwareID: product && product.HardwareID ? product.HardwareID : '',
        ANumber: product?.PCProduct?.ANumber ?? '',
        KeyboardLayoutCode: product?.PCProduct?.KeyboardLayoutCode ?? '',
    };

    let formSettings = {
        Validation: {
        },
        ButtonSubmit: hasPermission(permissions, "product_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null,
    };
    return (
        <>
            {!refresh ?

                <Paper className={classes.root} >
                    <PCProductForm
                        formSettings={formSettings}
                        initialValues={initialValues}
                        handleSubmit={handleSubmit}
                        editable={editable}
                        loading={loading}
                        translations={translations}
                    />
                </Paper> : null
            } </>
    )
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onEditPCProduct: product => dispatch(actions.editPCProduct(product)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(PCProductEditMisc));
